import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';

const GuestCount = (props) => {
  const { settings, reservationType } = props;
  return (
    <Field
      name="guestCount"
      className="c7-form-label__reservation-guests"
      component={SelectField}
      optionArray={reservationCount(settings, reservationType)}
      label="No of Guests"
      required
    />
  );
};

const reservationCount = (settings, reservationType) => {
  const array = [{ value: '', option: '' }];
  if (reservationType && reservationType.minGuestCount) {
    for (
      let i = reservationType.minGuestCount;
      i <= reservationType.maxGuestCount;
      i += 1
    ) {
      array.push({ option: `${i}`, value: `${i}` });
    }
    return array;
  }

  for (
    let i = settings.data.reservations.availabilityStartGuestCount;
    i <= settings.data.reservations.availabilityEndGuestCount;
    i += 1
  ) {
    array.push({ option: `${i}`, value: `${i}` });
  }

  return array;
};

export default GuestCount;
